export default "__VITE_ASSET__PrBMuZAJ__"